import React from 'react'
import styled from 'styled-components';
import WeekList from './WeekList.jsx';
import {device} from '../MainContents/Style/StyleDevice'

const TableWhitespace = styled.div`
    padding:30px 0px 30px;
    margin:30px 0px 30px;
`;

const TableWhitespaceColor = styled(TableWhitespace)`
    background-color: whitesmoke;
`;

const TableElementCenter = styled.td`
    height: 50px;
    vertical-align: middle!important;
`;
const CourseOption = styled.p`
    padding-left: 15px;
`;
const CourseIntroduction = styled.p`
    padding-left: 15px;
    color: red;
    font-size: 25px;
`;

const NewCourse = styled.h2`
    padding-left: 15px;
`;

const Margin = styled.div`
 margin: 30px 0px 30px;
`;
const TableMarginWid = styled.table`
    width: 90%;
    margin: auto;
    table-layout: fixed;
    word-wrap: break-word;
    display: table;
    @media ${device.laptop}{
    display: block !important;
    }
`;

const CourseTable = (props) => {
        const id = props.id;
        const weekdays = ['', '月', '火', '水', '木', '金', '土'];
      return (
           <Margin>
               {/* テーブル */}
               {/* 小学３年生 YTクラス */}
               {id== '1' &&
                    <TableWhitespace>
                        <CourseIntroduction >{props.heading}</CourseIntroduction>
                                <TableMarginWid className="table table-bordered text-center table-responsive table-scope">
                                <tbody>
                                <WeekList weekdays={weekdays} />
                                    <tr>
                                        <td>17:30～18:15</td>
                                        <td></td>
                                        <td>算数</td>
                                        <td></td>
                                        <td></td>
                                        <td>算個別</td>
                                        <TableElementCenter>算数<br/>11:00～11:45<br/></TableElementCenter>
                                    </tr>
                                    <tr>
                                        <td>18:20～19:05</td>
                                        <td></td>
                                        <td>国語</td>
                                        <td></td>
                                        <td></td>
                                        <td>国個別</td>
                                        <TableElementCenter>国語<br/>11:50～12:35<br/></TableElementCenter>
                                    </tr>
                                    {/* <tr>
                                        <td>18:25～19:15</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>算数</td>
                                    </tr> */}
                                </tbody>
                            </TableMarginWid>
                         <CourseOption style={{fontWeight : 'bold',color: 'red'}}>{props.detailComment}</CourseOption>
                         <CourseOption>{props.detailComment2}</CourseOption>
                         <CourseOption>{props.detailComment3}</CourseOption>
                    </TableWhitespace>
               }

            {/* 小学４年生　YTクラス(算国理コース) */}
               {id== '2' &&
                    <TableWhitespaceColor>
                    <CourseIntroduction>{props.heading}</CourseIntroduction>
                            <TableMarginWid className="table table-bordered text-center table-responsive table-scope">
                            <tbody>
                            <WeekList weekdays={weekdays} />
                                <tr>
                                    <td>16:40～17:25</td>
                                    <td></td>
                                    <td></td>
                                    <td>社補習</td>
                                    <td></td>
                                    <td>算個別</td>
                                    <TableElementCenter rowSpan="5">算数個別<br/>10:00～12:20<br/></TableElementCenter>
                                </tr>
                                <tr>
                                    <td>17:30～18:15</td>
                                    <td></td>
                                    <td>国語</td>
                                    <td>算数</td>
                                    <td></td>
                                    <td>算数</td>
                                </tr>
                                <tr>
                                    <td>18:20～19:05</td>
                                    <td></td>
                                    <td>理科</td>
                                    <td>算数</td>
                                    <td></td>
                                    <td>算数</td>
                                </tr>
                                <tr>
                                    <td>19:10～19:55</td>
                                    <td></td>
                                    <td>理科</td>
                                    <td>国語</td>
                                    <td></td>
                                    <td>国語</td>
                                </tr>
                            </tbody>
                        </TableMarginWid>
                     <CourseOption>{props.detailComment}</CourseOption>
                     <CourseOption>{props.detailComment2}</CourseOption>
                     <CourseOption>{props.detailComment3}</CourseOption>
                </TableWhitespaceColor>
               }
               {/* 小学5年生　YTクラス 新館2-2 */}
               {id== '3' &&
                    <TableWhitespace>
                    <CourseIntroduction>{props.heading}</CourseIntroduction>
                            <TableMarginWid className="table table-bordered text-center table-responsive table-scope">
                            <tbody>
                                <WeekList weekdays={weekdays} />
                                {/* <tr>
                                    <td>16:40～17:25</td>
                                    <td></td>
                                    <td></td>
                                    <td>算個別</td>
                                    <TableElementCenter rowSpan="6">17:30～20:45<br/>理社個別</TableElementCenter>
                                    <td></td>
                                    <TableElementCenter rowSpan="6">算数個別<br/>09:30～12:20<br/></TableElementCenter>
                                </tr> */}
                                <tr>
                                    <td>17:30～18:15</td>
                                    <td>算数</td>
                                    <td>理科</td>
                                    <td>社会</td>
                                    <td>理社補習</td>
                                    <td>理科</td>
                                    <TableElementCenter rowSpan="5">算数個別<br/>13:30～</TableElementCenter>
                                </tr>
                                <tr>
                                    <td>18:20～19:05</td>
                                    <td>算数</td>
                                    <td>算数</td>
                                    <td>社会</td>
                                    <td>理社補習</td>
                                    <td>理科</td>
                                </tr>
                                <tr>
                                    <td>19:10～19:55</td>
                                    <td>国語</td>
                                    <td>社会</td>
                                    <td>算数</td>
                                    <td></td>
                                    <td>算数</td>
                                </tr>
                                <tr>
                                    <td>20:00～20:45</td>
                                    <td>国語</td>
                                    <td>社会</td>
                                    <td>国語</td>
                                    <td></td>
                                    <td>国語</td>
                                </tr>
                            </tbody>
                        </TableMarginWid>
                     <CourseOption>{props.detailComment}</CourseOption>
                     <CourseOption>{props.detailComment2}</CourseOption>
                     <CourseOption>{props.detailComment3}</CourseOption>
                     <CourseOption>{props.detailComment4}</CourseOption>
                </TableWhitespace>
               }

               {/* 小学6年生　YTクラス */}
               {id== '4' &&
                <TableWhitespaceColor>
                    <CourseIntroduction>{props.heading}</CourseIntroduction><br />
                 <CourseOption>※{props.detailComment}</CourseOption>
                        <TableMarginWid className="table table-bordered text-center table-responsive table-scope">
                            <tbody>
                                <WeekList weekdays={weekdays} />
                                {/* <tr>
                                    <td>16:40～17:25</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <TableElementCenter rowSpan="6">17:30～20:45<br/>理社個別</TableElementCenter>
                                    <td></td>
                                    <TableElementCenter rowSpan="6">13:30～17:20<br/>週テスト＆補習授業</TableElementCenter>
                                </tr> */}
                                <tr>
                                    <td>17:30～18:15</td>
                                    <td>国語</td>
                                    <td>社会</td>
                                    <td>算数</td>
                                    <td>理社補習</td>
                                    <td>国語</td>
                                    <TableElementCenter rowSpan="5">算数個別<br/>13:00～</TableElementCenter>
                                </tr>
                                <tr>
                                    <td>18:20～19:05</td>
                                    <td>国語</td>
                                    <td>社会</td>
                                    <td>算数</td>
                                    <td>理社補習</td>
                                    <td>国語</td>
                                </tr>
                                <tr>
                                    <td>19:10～19:55</td>
                                    <td>理科</td>
                                    <td>算数</td>
                                    <td>社会</td>
                                    <td></td>
                                    <td>算数</td>
                                </tr>
                                <tr>
                                    <td>20:00～20:45</td>
                                    <td>理科</td>
                                    <td>算数</td>
                                    <td>理科</td>
                                    <td></td>
                                    <td>理科</td>
                                </tr>
                                <tr>
                                    <td>20:50～21:20</td>
                                    <td>算個別</td>
                                    <td>理個別</td>
                                    <td>国個別</td>
                                    <td></td>
                                    <td>算個別</td>
                                </tr>
                            </tbody>
                        </TableMarginWid>   
                </TableWhitespaceColor>
               }

           </Margin>
      );
};
  

export default CourseTable;